import {
  Checkbox,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { isEqual, remove } from "lodash";

type MultipleOptionProps<T> = Partial<{
  value: Array<T>;
  children: React.ReactNode;
  limit: number;
}> & {
  item: T;
  onChange: (data: Array<T>) => void;
  getOptionLabel: (data: T) => React.ReactNode;
};

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions,react/function-component-definition
function MultipleOption<T>({
  children,
  item,
  value = [],
  onChange,
  getOptionLabel,
  limit = 5,
}: MultipleOptionProps<T>): React.ReactElement {
  const [checked, setChecked] = useState(
    !!value?.find((selected) => isEqual(selected, item))
  );

  useEffect(() => {
    setChecked(!!value?.find((selected) => isEqual(selected, item)));
  }, [item, value]);

  return (
    <ListItem
      className="w-[inherit] p-0"
      onClick={() => {
        setChecked((prevChecked) => {
          if (value.length === limit && !prevChecked) {
            // TODO Throw toast inidcating the user that the limit of selected items were reached
            return prevChecked;
          }

          const emptyArray = [] as Array<T>;
          const valueBase: Array<T> = value?.length ? value : emptyArray;

          onChange(
            prevChecked
              ? remove(valueBase, (selected) => !isEqual(selected, item))
              : [...valueBase, item]
          );

          return !prevChecked;
        });
      }}
    >
      <ListItemIcon className="min-w-0">
        <Checkbox
          edge="start"
          size="small"
          checked={checked}
          tabIndex={-1}
          disableRipple
          className="text-gray-500"
        />
      </ListItemIcon>
      <ListItemText
        primary={
          children ?? (
            <p className="w-full truncate leading-none text-gray-500">
              {item ? getOptionLabel(item) : ""}
            </p>
          )
        }
      />
    </ListItem>
  );
}

export { MultipleOption };
